<template lang="pug">
  .play-guide-container
    GoodsPopup(
      :visible="currentStep === 1"
      :goodsInfo="info"
      @btnClick="handleGoodsBtnClick"
      @nextClick="handleNextStep"
    )
    .play-guide-body(
      v-if="isVisible && currentStep !== 1"
      @touchmove.prevent
      @click.stop
    )
      HollowGuide(
        v-if="currentStep === 2"
        :goodsInfo="info"
        :newExchange="newExchange"
        @nextClick="handleNextStep"
        @breakOff="handleSkipClick"
      )
      TeachGuide(
        v-if="currentStep === 3"
        :goodsInfo="info"
        @nextClick="handleNextStep"
        @skipClick="handleSkipClick"
      )
</template>

<script>
import GoodsPopup from './goods-popup';
import HollowGuide from './hollow-guide';
import TeachGuide from './teach-guide';

export default {
  name: 'AwardGuidePopup',
  components: {
    GoodsPopup,
    HollowGuide,
    TeachGuide,
  },
  props: {
    // 是否显示
    visible: {
      type: Boolean,
      default: false,
    },
    // 玩法引导弹窗信息
    info: {
      type: Object,
      default: () => {},
    },
    // 是否是新版兑换商品
    newExchange: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 当前步骤
      currentStep: 0,
      // 是否显示
      isVisible: false,
    };
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          this.currentStep = 1;
        }
        this.isVisible = newVal;
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    // 兑换商品点击
    handleNextStep() {
      if (this.currentStep === 3) {
        this.isVisible = false;
        this.$emit('close');
        return;
      }
      const nextStep = this.currentStep + 1;
      this.currentStep = nextStep;
    },
    // 商品弹窗卡片按钮点击
    handleGoodsBtnClick() {
      this.$emit('goodsClick');
    },
    // 中断/跳过引导流程
    handleSkipClick() {
      this.isVisible = false;
      this.$emit('close');
    },
  },
};
</script>

<style lang="less" scoped>
.play-guide-container {
  .play-guide-body {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 999;
    touch-action: none;
    user-select: none;
    -webkit-user-select: none;
    -webkit-touch-action: none;
  }
}
</style>
